export const EMAIL_ACCOUNTS_RESET_STATE = 'EMAIL_ACCOUNTS_RESET_STATE';
export const EMAIL_ACCOUNTS_CURRENT_ITEM = 'EMAIL_ACCOUNTS_CURRENT_ITEM';

export const EMAIL_ACCOUNTS_REQUEST_LOADING = 'EMAIL_ACCOUNTS_REQUEST_LOADING';
export const EMAIL_ACCOUNTS_REQUEST_SUCCESS = 'EMAIL_ACCOUNTS_REQUEST_SUCCESS';
export const EMAIL_ACCOUNTS_REQUEST_FAILED = 'EMAIL_ACCOUNTS_REQUEST_FAILED';

export const EMAIL_ACCOUNTS_CURRENT_ACTION = 'EMAIL_ACCOUNTS_CURRENT_ACTION';
export const EMAIL_ACCOUNTS_RESET_ACTION = 'EMAIL_ACCOUNTS_RESET_ACTION';